import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';

import { Button, type ButtonProps } from '@openx/components-core/lib/Button/Button.tsx';

import type { JSX } from 'react';

export interface ActionButtonProps extends ButtonProps {
  label: string;
  color: NonNullable<ButtonProps['color']>;
  href?: string;
  isAllowed?: boolean;
  isHidden?: boolean;
  showAsActionButton?: boolean;
  showAsDivider?: boolean;
  sx?: SxProps<Theme>;
}

export function ActionButton({
  isAllowed = true,
  label,
  isHidden = false,
  loading = false,
  showAsActionButton,
  showAsDivider,
  sx,
  ...props
}: ActionButtonProps): JSX.Element | null {
  if (isHidden) {
    return null;
  }

  if (showAsDivider) {
    return <Divider orientation="vertical" flexItem sx={{ m: 0.75 }} />;
  }

  return (
    <Grid>
      <Button
        data-test={props['data-test'] || 'action-button'}
        allowed={isAllowed}
        loading={loading}
        sx={sx}
        {...props}
      >
        {label}
      </Button>
    </Grid>
  );
}
